module.exports = __webpack_public_path__ + "img/whats-new-13_en.6d205cc.jpg";